import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import Select from "react-select";
import PoPrintModal from './PoPrintModal';
import POEditModal from "./POEditModal";
import POLogsModal from "./PoLogsModal";
import PoServices from "../../../services/PoServices";
import RepairPoServices from "../../../services/RepairPoServices";
import Spinner from 'react-bootstrap/Spinner';
import * as XLSX from "xlsx";

const CheckkarRepairPoList = () => {
  // user from localStorage (make sure structure matches your app)
  //const user = JSON.parse(localStorage.getItem('userDetails') || '{}');

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [sort, setSort] = useState(20);
  const [searchTerm, setSearchTerm] = useState("");
  const activePag = useRef(0);
  const [test, setTest] = useState(0);
  const [loading, setLoading] = useState(true);


  // Modal states (IMPORTANT: these must be declared)
  const [printModalOpen, setPrintModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItem2, setSelectedItem2] = useState(null);
  const [selectedItem3, setSelectedItem3] = useState(null);

  // add this line near your other useState hooks
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [gridInsideModal3, setGridInsideModal3] = useState(false);




  const options = [
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
  ];

  // 👇 Move this OUTSIDE useEffect so you can reuse it
  const fetchPurchaseOrders = async (userRole) => {
    let status = 'Generated'
    try {
      setLoading(true);
      const res = await RepairPoServices.AllPOByStatus(status);
      setPurchaseOrders(res?.data || []);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch purchase orders", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPurchaseOrders(); // ✅ call with current role
  }, [test]); // re-run if role or test changes



  const filteredSearch = purchaseOrders.filter(po => {
    const requisitionNumber = po?.requisitionNo?.requisitionNo?.toString() || "";
    const poNumber = po?.poNumber?.toString() || "";
    const supplierName = po?.items?.[0]?.supplier?.name?.toLowerCase() || "";
    const createdBy = po?.createdBy?.name?.toLowerCase() || "";
    const storeLocation = po?.requisitionNo?.store?.name?.toLowerCase() || "";

    // ✅ Join all item descriptions into one string
    const description = po?.items?.map(item => item?.description?.toLowerCase() || "")
      .join(" ") || "";

    const search = searchTerm.toLowerCase();

    return (
      requisitionNumber.includes(search) ||
      poNumber.includes(search) ||
      supplierName.includes(search) ||
      createdBy.includes(search) ||
      storeLocation.includes(search) ||
      description.includes(search)   // ✅ now works
    );
  });



  const pagination = Math.ceil(filteredSearch.length / sort);

  const onClick = (i) => {
    activePag.current = i;
    setTest(i);
  };

  const handleViewClick = (poDetails) => {
    setSelectedItem(poDetails);       // set item to pass into modal
    setGridInsideModal(true);         // show modal
  };


  const handleViewLogs = (poDetails) => {
    setSelectedItem3(poDetails);       // set item to pass into modal
    setGridInsideModal3(true);         // show modal
  };

  const handleAssign = async (poId, action) => {
    try {
      // ✅ Ask user for remark before proceeding
      const { value: remark } = await Swal.fire({
        title: "Enter Remark",
        input: "textarea",
        inputLabel: "Remark is required",
        inputPlaceholder: "Type your remark here...",
        inputAttributes: {
          "aria-label": "Type your remark here"
        },
        showCancelButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel",
        inputValidator: (value) => {
          if (!value) {
            return "Remark is required!";
          }
        }
      });

      if (!remark) {
        return; // user cancelled or didn’t type
      }

      setLoading(true);

      const body = { poId, action, remark };

      const res = await RepairPoServices.approvePO(body);

      Swal.fire("Success", res.message, "success");

      // ✅ increment test value
      setTest((prev) => prev + 1);

      // refresh list after update
      fetchPurchaseOrders();

    } catch (error) {
      console.error("Error in handleAssign:", error);
      Swal.fire("Error", error?.response?.data?.message || "Failed to update PO", "error");
    } finally {
      setLoading(false);
    }
  };



  // ✅ Download as Excel (with Amount & Total)
  const handleDownloadExcelWithAmount = () => {
    const exportData = filteredSearch.map((row, index) => {
      const qtys = row?.items?.map((i) => i?.approveQty || 0);
      const rates = row?.items?.map((i) => i?.rate || 0);
      const amounts = row?.items?.map((i) => (i?.approveQty || 0) * (i?.rate || 0));
      const totalAmount = amounts.reduce((sum, val) => sum + val, 0);

      return {
        "#": index + 1,
        Requisition: row?.requisitionNo?.requisitionNo || row?.requisitionNo?._id || "N/A",
        "Repair Order No.": row?.poNumber || "N/A",
        "Part Nos": row?.items?.map((i) => i?.partNo).join(", ") || "N/A",
        Descriptions: row?.items?.map((i) => i?.description).join(", ") || "N/A",
        Qty: qtys.join(", ") || "N/A",
        Rate: rates.join(", ") || "N/A",
        Amount: amounts.join(", ") || "N/A",   // per-item amounts
        "Total Amount": totalAmount,           // row-level total
        Store: row?.requisitionNo?.store?.name || "N/A",
        Supplier: row?.items?.map((i) => i?.supplier?.name).join(", ") || "N/A",
        "Delivery Address": `${row?.deliveryAddress?.street}, ${row?.deliveryAddress?.city}, ${row?.deliveryAddress?.state} - ${row?.deliveryAddress?.pincode}, ${row?.deliveryAddress?.country}`,
        CreatedAt: new Date(row?.createdAt).toLocaleDateString("en-IN"),
        "Total Items": row?.items?.length || 0,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PurchaseOrders");
    XLSX.writeFile(workbook, "PurchaseOrders_WithAmount.xlsx");
  };




  return (
    loading ? (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <Spinner animation="border" role="status" variant="primary" />
        <p className="mt-2 fw-bold text-primary">Loading Repair Orders...</p>
      </div>
    ) : (
      <>

        <PoPrintModal
          show={gridInsideModal}
          onHide={() => setGridInsideModal(false)}
          item={selectedItem}
        />


        {gridInsideModal3 && selectedItem3 && (
          <POLogsModal
            show={gridInsideModal3}
            handleClose={() => setGridInsideModal3(false)}
            item={selectedItem3}
            test={setTest}
            handleAssign={handleAssign}   // ✅ REQUIRED
          />

        )}



        <div className="row">
          <div className="col-xl-12">

            {/* Filter */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa"><i className="fas fa-filter me-2"></i>Filter</div>
                <div className="tools">
                  <Link to="#" className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`} onClick={() => setOpen(!open)}>
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-xxl-6 mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by Requisition No., Po Number, Supplier Name, Store, description"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                      <div className="col-xl-3 col-xxl-6 mb-3">
                        <Select
                          placeholder="Rows per page"
                          value={options.find(option => option.value === sort)}
                          onChange={(selectedOption) => setSort(Number(selectedOption.value))}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            {/* Table */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title d-flex justify-content-between align-items-center">
                <div className="cpa">
                  <i className="fa fa-list me-2"></i>All Purchase Orders
                  <span className="badge bg-orange ms-2">{filteredSearch.length}</span>
                </div>
                <div className="d-flex align-items-center">
                  <button
                    className="btn btn-sm btn-primary me-2"
                    onClick={handleDownloadExcelWithAmount}
                  >
                    <i className="fa fa-download me-1"></i>Download Excel
                  </button>
                  <div className="tools">
                    <Link
                      to="#"
                      className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                      onClick={() => setOpen2(!open2)}
                    >
                      <i className="fas fa-angle-up"></i>
                    </Link>
                  </div>
                </div>
              </div>


              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div id="content_wrapper" className="dataTables_wrapper no-footer">
                        <div style={{
                          overflowX: 'auto',
                          overflowY: 'auto',
                          maxHeight: '400px',
                          whiteSpace: 'nowrap'
                        }}>
                          <table className="table table-bordered table-responsive-lg table-striped table-condensed flip-content" id="active-users-data">
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                backgroundColor: "#fff", // White background
                                zIndex: 2,
                              }}
                            >
                              <tr>
                                <th>#</th>
                                <th>Request No.</th>
                                <th>Repair Order</th>
                                <th>Type</th>
                                <th>Inv Part No</th>
                                <th>Inv Description</th>
                                <th>Repair Part No</th>
                                <th>Repair Part Description</th>
                                <th>Qty</th>
                                <th>Rate</th>
                                <th>Store</th>
                                <th>Suppplier</th>
                                <th>Deliver Address</th>
                                <th>CreatedAt</th>
                                <th>Items</th>
                                <th>Print</th>
                                <th className="text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredSearch.length > 0 ? (
                                filteredSearch
                                  .slice(activePag.current * sort, (activePag.current + 1) * sort)
                                  .map((row, index) => (
                                    <tr key={index}>

                                      {/* # */}
                                      <td>{activePag.current * sort + index + 1}</td>

                                      {/* Request No */}
                                      <td>{row?.repairOrder?.repairOrderNo || "N/A"}</td>

                                      {/* PO Number */}
                                      <td>{row?.poNumber || "N/A"}</td>

                                      {/* Type */}
                                      <td>{row?.poType || "Normal"}</td>

                                      {/* Inventory Part No */}
                                      <td>
                                        {row?.repairOrder?.inventory?.masterItem?.partNo || "N/A"}
                                      </td>

                                      {/* Inventory Description */}
                                      <td className="scrollable-description">
                                        {row?.repairOrder?.inventory?.masterItem?.description || "N/A"}
                                      </td>

                                      {/* Repair Part No */}
                                      <td>
                                         {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.partNo || ''}</div>
                                        ))}
                                      </td>

                                      {/* Repair Part Description */}
                                      <td className="scrollable-description">
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.description || ''}</div>
                                        ))}
                                        
                                      </td>

                                      {/* Qty */}
                                      <td>
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.approveQty || 0}</div>
                                        ))}
                                      </td>

                                      {/* Rate */}
                                      <td>
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.rate || 0}</div>
                                        ))}
                                      </td>

                                      {/* Store */}
                                      <td className="scrollable-description">
                                        {row?.repairOrder?.store?.name || "N/A"}
                                      </td>

                                      {/* Supplier */}
                                      <td className="scrollable-description">
                                        {row?.supplier?.name || "N/A"}
                                      </td>

                                      {/* Delivery Address */}
                                      <td className="scrollable-description">
                                        {row?.supplier?.address?.street}, {row?.supplier?.address?.city},
                                        <br />
                                        {row?.supplier?.address?.state} - {row?.supplier?.address?.pincode},
                                        <br />
                                        {row?.supplier?.address?.country}
                                      </td>

                                      {/* Created At */}
                                      <td>{new Date(row?.createdAt).toLocaleDateString("en-IN")}</td>

                                      {/* Items count */}
                                      <td>{row?.items?.length || 0}</td>

                                      {/* Print button */}
                                      <td>
                                        <button
                                          className="btn btn-success btn-xs"
                                          onClick={() => handleViewClick(row)}
                                        >
                                          Print
                                        </button>
                                      </td>

                                      {/* Action buttons */}
                                      <td>
                                        <div className="d-flex gap-2 justify-content-center">
                                          <button
                                            className="btn btn-primary py-1 px-2"
                                            style={{ width: "60px", borderRadius: "8px", height: "55px" }}
                                            onClick={() => handleViewLogs(row)}
                                          >
                                            <i className="fa fa-eye text-white fs-5 mb-1"></i>
                                            <span className="text-white" style={{ fontSize: "10px" }}>
                                              View
                                            </span>
                                          </button>

                                          <button
                                            className="btn btn-warning py-1 px-2"
                                            style={{ width: "60px", borderRadius: "8px", height: "55px" }}
                                            onClick={() => handleAssign(row?._id, "Send-Back")}
                                          >
                                            <i className="fa fa-eye text-white fs-5 mb-1"></i>
                                            <span className="text-white" style={{ fontSize: "10px" }}>
                                              Maker
                                            </span>
                                          </button>

                                          <button
                                            className="btn btn-warning py-1 px-2"
                                            style={{ width: "65px", borderRadius: "8px", height: "55px" }}
                                            onClick={() => handleAssign(row?._id, "Approved")}
                                          >
                                            <i className="fa fa-eye text-white fs-5 mb-1"></i>
                                            <span className="text-white" style={{ fontSize: "10px" }}>
                                              Approve
                                            </span>
                                          </button>
                                        </div>
                                      </td>

                                    </tr>
                                  ))
                              ) : (
                                <tr>
                                  <td colSpan="16" className="text-center">
                                    No Repair Orders Found
                                  </td>
                                </tr>
                              )}
                            </tbody>

                          </table>
                        </div>
                        {/* Pagination */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing {filteredSearch.length > 0 ? (activePag.current * sort + 1) : 0} to{" "}
                            {Math.min(filteredSearch.length, (activePag.current + 1) * sort)} of {filteredSearch.length} entries
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers">
                            <Link className="paginate_button previous" to="#" onClick={() => activePag.current > 0 && onClick(activePag.current - 1)}>
                              <i className="fa fa-angle-double-left"></i>
                            </Link>
                            <span>
                              {Array.from({ length: pagination }, (_, i) => (
                                <Link
                                  key={i}
                                  to="#"
                                  className={`paginate_button ${activePag.current === i ? "current" : ""}`}
                                  onClick={() => onClick(i)}
                                >
                                  {i + 1}
                                </Link>
                              ))}
                            </span>
                            <Link className="paginate_button next" to="#" onClick={() => activePag.current < pagination - 1 && onClick(activePag.current + 1)}>
                              <i className="fa fa-angle-double-right"></i>
                            </Link>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      </>
    )
  );

};

export default CheckkarRepairPoList;
